import {
  IDepartmentBoardTask,
  ITeamMember,
  IResourceStatus,
  IMachineDown,
  IPartAtRisk,
  ILocationStatus,
  IPostCoverage,
  TaskStatus,
} from '../types/operations.types'

export const MOCK_RESOURCE_STATUS: IResourceStatus = {
  workforce: { available: 12, assigned: 58, onBreak: 8, unavailable: 4 },
  machines: { active: 14, idle: 3, maintenance: 2, offline: 1 },
}

export const MOCK_TEAM_MEMBERS: ITeamMember[] = [
  { id: 'tm-1', name: 'Peter M.', role: 'Truck Operator', status: 'busy', currentTask: 'Haul Cycle #147', utilization: 92 },
  { id: 'tm-2', name: 'Michael K.', role: 'Truck Operator', status: 'busy', currentTask: 'Haul Cycle #148', utilization: 88 },
  { id: 'tm-3', name: 'John S.', role: 'Truck Operator', status: 'blocked', currentTask: 'Haul Cycle #145', utilization: 45 },
  { id: 'tm-4', name: 'Daniel R.', role: 'Excavator Operator', status: 'busy', currentTask: 'Excavation Seg. 14', utilization: 95 },
  { id: 'tm-5', name: 'Nicholas T.', role: 'Truck Operator', status: 'busy', currentTask: 'Haul Cycle #146', utilization: 78 },
  { id: 'tm-6', name: 'Anna V.', role: 'Inspector', status: 'busy', currentTask: 'Inspection #22', utilization: 72 },
  { id: 'tm-7', name: 'Robert G.', role: 'Mechanic', status: 'available', utilization: 0 },
  { id: 'tm-8', name: 'Thomas W.', role: 'Truck Operator', status: 'waiting', currentTask: 'Waiting for assignment', utilization: 15 },
]

export const MOCK_MAINTENANCE_TASKS: IDepartmentBoardTask[] = [
  {
    id: 'mt-1', name: 'Hydraulic System Repair', machine: 'CAT320', operator: 'Robert G.',
    status: TaskStatus.InProgress, statusLabel: 'In Progress', eta: '2h',
    location: 'Workshop A', source: 'TRIGGER', priority: 'Critical',
    assignee: 'Robert G.', sourceBadge: 'TRIGGER', subtitle: 'CAT320 - Hydraulic pressure anomaly',
    impactText: 'Blocks Excavation Plan',
  },
  {
    id: 'mt-2', name: 'Scheduled Greasing', operator: 'James L.',
    status: TaskStatus.NotStarted, statusLabel: 'Queued',
    location: 'Fleet Yard', source: 'SHIFT_PROGRAM', priority: 'Medium',
    assignee: 'James L.', sourceBadge: 'SHIFT_PROGRAM', subtitle: 'Truck 03, 05, 08',
  },
  {
    id: 'mt-3', name: 'Brake Inspection', machine: 'Truck 12', operator: 'Robert G.',
    status: TaskStatus.NotStarted, statusLabel: 'Queued',
    location: 'Workshop A', source: 'PLAN', priority: 'High',
    assignee: undefined, sourceBadge: 'PLAN', subtitle: 'Truck 12 - 500hr service',
    partsMissing: true,
  },
  {
    id: 'mt-4', name: 'Engine Diagnostic', machine: 'Truck 07',
    status: TaskStatus.Paused, statusLabel: 'Paused', eta: '45m',
    location: 'Workshop B', source: 'PROBLEM_RESOLVER', priority: 'Critical',
    assignee: 'Thomas W.', sourceBadge: 'PROBLEM_RESOLVER', subtitle: 'Truck 07 - Fuel system issue',
    impactText: 'Fuel alert active',
  },
]

export const MOCK_CAMP_TASKS: IDepartmentBoardTask[] = [
  {
    id: 'ct-1', name: 'Morning Cleaning - Block A',
    status: TaskStatus.Completed, statusLabel: 'Completed',
    location: 'Block A', source: 'SHIFT_PROGRAM', priority: 'Medium',
    assignee: 'Sarah K.', sourceBadge: 'SHIFT_PROGRAM', subtitle: 'Block A - Dormitory',
  },
  {
    id: 'ct-2', name: 'Morning Cleaning - Block B',
    status: TaskStatus.InProgress, statusLabel: 'In Progress', eta: '30m',
    location: 'Block B', source: 'SHIFT_PROGRAM', priority: 'Medium',
    assignee: 'Maria P.', sourceBadge: 'SHIFT_PROGRAM', subtitle: 'Block B - Dormitory',
  },
  {
    id: 'ct-3', name: 'Kitchen Deep Clean',
    status: TaskStatus.NotStarted, statusLabel: 'Queued',
    location: 'Main Kitchen', source: 'SHIFT_PROGRAM', priority: 'High',
    assignee: undefined, sourceBadge: 'SHIFT_PROGRAM', subtitle: 'Main Kitchen',
  },
  {
    id: 'ct-4', name: 'Water Tank Inspection',
    status: TaskStatus.NotStarted, statusLabel: 'Queued',
    location: 'Water Treatment', source: 'TRIGGER', priority: 'High',
    assignee: 'David M.', sourceBadge: 'TRIGGER', subtitle: 'Water Treatment Plant',
  },
]

export const MOCK_SECURITY_TASKS: IDepartmentBoardTask[] = [
  {
    id: 'st-1', name: 'Perimeter Patrol - North',
    status: TaskStatus.InProgress, statusLabel: 'On Post', eta: '45m',
    location: 'North Perimeter', source: 'SHIFT_PROGRAM', priority: 'High',
    assignee: 'Alex B.', sourceBadge: 'SHIFT_PROGRAM', subtitle: 'North Perimeter Fence',
  },
  {
    id: 'st-2', name: 'Gate Control - Main',
    status: TaskStatus.InProgress, statusLabel: 'On Post',
    location: 'Main Gate', source: 'SHIFT_PROGRAM', priority: 'Critical',
    assignee: 'Victor S.', sourceBadge: 'SHIFT_PROGRAM', subtitle: 'Main Gate Access Point',
  },
  {
    id: 'st-3', name: 'Incident Report - Unauthorized Access',
    status: TaskStatus.InProgress, statusLabel: 'In Progress', eta: '1h',
    location: 'Zone C', source: 'PROBLEM_RESOLVER', priority: 'Critical',
    assignee: 'Alex B.', sourceBadge: 'PROBLEM_RESOLVER', subtitle: 'Zone C - East Fence Breach',
    impactText: 'Security escalation active',
  },
]

export const MOCK_MINING_TASKS: IDepartmentBoardTask[] = [
  {
    id: 'mnt-1', name: 'Haul Cycle #147', machine: 'Truck 12',
    status: TaskStatus.InProgress, statusLabel: 'In Progress', eta: '18m',
    location: 'Pit B to Crusher', source: 'PLAN', priority: 'High',
    assignee: 'Peter M.', sourceBadge: 'PLAN', subtitle: 'Ore Haulage Plan',
  },
  {
    id: 'mnt-2', name: 'Excavation Segment 14', machine: 'CAT320',
    status: TaskStatus.InProgress, statusLabel: 'In Progress', eta: '34m',
    location: 'Zone B North', source: 'PLAN', priority: 'Critical',
    assignee: 'Daniel R.', sourceBadge: 'PLAN', subtitle: 'Excavation Plan - Zone B',
  },
  {
    id: 'mnt-3', name: 'Haul Cycle #145', machine: 'Truck 03',
    status: TaskStatus.Stopped, statusLabel: 'Blocked',
    location: 'Crusher Queue', source: 'PLAN', priority: 'Critical',
    assignee: 'John S.', sourceBadge: 'PLAN', subtitle: 'Blocked at crusher - queue full',
    impactText: 'Crusher throughput reduced',
  },
]

export const MOCK_MACHINES_DOWN: IMachineDown[] = [
  { id: 'md-1', machineName: 'CAT320', machineId: 'MC-320-01', downSince: '2026-03-26T08:30:00Z', reason: 'Hydraulic pressure anomaly', impactedPlan: 'Excavation - Zone B North' },
  { id: 'md-2', machineName: 'Truck 07', machineId: 'TR-07', downSince: '2026-03-26T10:15:00Z', reason: 'Fuel system fault', impactedPlan: 'Ore Haulage - Pit B' },
]

export const MOCK_PARTS_AT_RISK: IPartAtRisk[] = [
  { id: 'pr-1', partName: 'Hydraulic Pump Seal Kit', forMachine: 'CAT320', orderStatus: 'In Transit - ETA 2h' },
  { id: 'pr-2', partName: 'Brake Pads - Heavy Duty', forMachine: 'Truck 12', orderStatus: 'Backordered' },
]

export const MOCK_LOCATION_STATUS: ILocationStatus[] = [
  { id: 'ls-1', locationName: 'Block A - Dormitory', status: 'Done', assignedWorker: 'Sarah K.' },
  { id: 'ls-2', locationName: 'Block B - Dormitory', status: 'In Progress', assignedWorker: 'Maria P.' },
  { id: 'ls-3', locationName: 'Main Kitchen', status: 'Queued' },
  { id: 'ls-4', locationName: 'Recreation Hall', status: 'Queued' },
  { id: 'ls-5', locationName: 'Admin Office', status: 'Done', assignedWorker: 'Lisa T.' },
]

export const MOCK_POST_COVERAGE: IPostCoverage[] = [
  { id: 'pc-1', postName: 'Main Gate', guardsCount: 2, coverageStatus: 'Covered', nextHandover: '18:00' },
  { id: 'pc-2', postName: 'North Perimeter', guardsCount: 1, coverageStatus: 'Covered', nextHandover: '18:00' },
  { id: 'pc-3', postName: 'Equipment Yard', guardsCount: 0, coverageStatus: 'Uncovered', nextHandover: '14:00' },
  { id: 'pc-4', postName: 'Processing Plant', guardsCount: 1, coverageStatus: 'Covered', nextHandover: '18:00' },
]
